export enum ScoreRatingEnum {
  Unsatisfactory = 1,
  Bad = 2,
  Good = 3,
  Satisfactory = 4,
  Excellent = 5
}
